import {
  FormWrapper,
  Page,
  Header,
  SubTitle,
  PageDisclaimer,
  QrcodeUnitInfo,
  FormInputsWrapper,
  StyledFormGroup,
  StyledSelect,
  StyledInputMask,
  ErrorText,
  SaveButton,
  SuccessModal,
  QrcodeTableInfo,
  QrcodeTableInfoIcon,
  QrcodeTableInfoBody,
} from './styled';
import { ReactComponent as QrcodeIcon } from './assets/qr-code-icon.svg';
import { ReactComponent as SuccessIcon } from 'assets/icons/success-checkmark.svg';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { useMediaQuery } from 'react-responsive';
import { Textarea } from 'components/Form/subcomponents/Textarea';
//import InputMask from 'react-input-mask';
import { useRef, useEffect, useState, useContext } from 'react';
import ImageUpload from './components/ImageUpload';
import { SelectCheckbox } from './components/SelectCheckbox';
import { useCookies } from 'react-cookie';
import { Loading, Toast } from 'components';
import { createErrorToast, createGenericErrorToast } from 'utils/createToast';
import { AuthService } from 'services/main';
import { ChamadoService } from 'services/main/endpoints/ChamadoService';
//import { FiltersService } from 'services/reports/endpoints/FiltersService';
import { AuthContext } from 'context/AuthContext';
import { URLS } from 'constants/urls';
import { useHistory, useParams } from 'react-router-dom';
import { parseJwt } from 'utils/parse';
import { handleImageUpload } from 'utils/imageUpload';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import { getTheme, getAuth } from './themes';
// const categories = [
//   { label: 'Chamado', value: 'chamado' },
//   { label: 'Sugestão', value: 'sugestao' },
//   { label: 'Crítica', value: 'critica' },
// ];
export const ChamadoWoba = () => {
  const { push } = useHistory();
  const [fields, setFields] = useState();
  const [loading, setLoading] = useState(true);
  const [cookie, setCookie, removeCookie] = useCookies();
  const { authContext, setAuthContext } = useContext(AuthContext);
  const [toastList, setToastList] = useState([]);
  const { qrcode } = useParams();
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const textAreaRef = useRef(null);
  const isDesktop = useMediaQuery({ minWidth: 1081 });
  const theme = getTheme(cookie?.chamadoWoba?.empresa);
  const { Logo } = theme;
  const methods = useForm({
    defaultValues: {
      nome: '',
      area: '',
      solicitationType: [],
      details: '',
      email: '',
      fotos: [],
      categoriy: '',
    },
  });
  const {
    control,
    //register,
    handleSubmit,
    //getValues,
    setValue,
    //reset,
    watch,
    formState: { errors },
  } = methods;
  const detailsValue = watch('details');

  useEffect(() => {
    const textarea = textAreaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [detailsValue]);
  const closeModals = () => {
    setOpenModalSuccess(false);
  };
  useEffect(() => {
    setLoading(true);
    if (cookie?.chamadoWoba?.qrcode != qrcode) {
      push(`/qr/${qrcode}`);
      return;
    } else if (!cookie?.chamadoWoba) {
      push('/logout');
    }
    // const loginObj =
    //   cookie?.chamadoWoba?.empresa === 4157
    //     ? {
    //         login: 'vald',
    //         password: 'Hom@2025',
    //         stayLogged: true,
    //         expireCurrentSession: true,
    //       }
    //     : {
    //         login: 'cliente.woba',
    //         password: 'Hom@2025',
    //         stayLogged: true,
    //         expireCurrentSession: true,
    //       };
    const auth = getAuth(cookie?.chamadoWoba?.empresa, theme);
    handleLogin({ ...auth, stayLogged: true, expireCurrentSession: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLogin = async ({ login, password, stayLogged, expireCurrentSession }) => {
    const response = await AuthService.login({
      login,
      password,
      withRefreshToken: stayLogged,
      stayConnected: stayLogged,
      expireCurrentSession: expireCurrentSession,
    });

    if (response.status === 200) {
      const {
        data: { user, ...authData },
      } = response;

      try {
        setCookie('authToken', authData.authToken.token, { path: '/', domain: URLS.cookieDomain });
        setCookie('refreshToken', authData?.authToken?.refreshToken, {
          path: '/',
          domain: URLS.cookieDomain,
        });
        setCookie('chamadoRoute', `/chamado/${qrcode}`, { path: '/', domain: URLS.cookieDomain });
        const { utyp } = parseJwt(authData.authToken.token);
        const { isSuper, isAdmin, isOperationalUser, isCommonUser } = {
          isSuper: parseInt(utyp) === 1,
          isAdmin: parseInt(utyp) === 2,
          isOperationalUser: parseInt(utyp) === 3,
          isCommonUser: parseInt(utyp) === 4,
        };

        const permissionType = isSuper ? 'super' : isAdmin ? 'admin' : 'user';
        const userType = isSuper
          ? 'Super-Usuário'
          : isAdmin
          ? 'Administrador'
          : isOperationalUser
          ? 'Operacional'
          : isCommonUser
          ? 'Chamado'
          : createGenericErrorToast(setToastList);

        const userResponse = await AuthService.getUser({
          id: user?.id,
          token: authData.authToken.token,
        });
        user.fullName = userResponse.data.nome;

        const signUpDateUnix = Math.floor(new Date(userResponse.data.dataCadastro).getTime() / 1000);
        user.signUpDate = signUpDateUnix;
        setAuthContext({
          ...authContext,
          isAuthenticated: true,
          statusCode: true,
          token: authData?.authToken?.token,
          refreshToken: authData?.authToken?.refreshToken,
          expiresIn: authData?.authToken?.expiresIn,
          user: {
            id: user?.id,
            name: user?.name,
            permissionType,
            type: userType,
            fullName: user?.fullName,
            signUpUnixDate: user?.signUpDate,
          },
        });
        await fetchData();
      } catch (e) {
        console.error(`userResponse err`);
        console.error(e);
        push('/logout');
      }
    }
  };
  const populateFields = async () => {
    const companyId = cookie?.chamadoWoba?.empresa;
    const unitId = cookie?.chamadoWoba?.site;
    const response = await Promise.all([
      ChamadoService.getAreas({
        empresa: companyId,
        siteId: unitId,
        PageIndex: 1,
        PageSize: 310,
      }),
      ChamadoService.getOcorrenciasTipicas({
        EmpresaId: companyId,
        UnidadeId: unitId,
      }),
    ]);
    setFields({
      area: response[0]?.data.map(({ area, identificacaoAmbiente, ...rest }) => ({
        label: identificacaoAmbiente,
        value: area,
        ...rest,
      })),
      typical: response[1]?.data?.map(({ descricao, anomaliaId, ...rest }) => ({
        label: descricao,
        value: anomaliaId,
        ...rest,
      })),
      category: response[1]?.data?.map(({ descricao, anomaliaId, ...rest }) => ({
        label: descricao,
        value: anomaliaId,
        ...rest,
      })),
    });
  };
  const fetchData = async () => {
    try {
      await populateFields();
      setLoading(false);
    } catch (err) {
      if (err.message.includes('Network Error')) {
        history.push('/conection-error');
      }

      createGenericErrorToast(setToastList);
    }
  };
  const handleSave = async data => {
    const { fotos } = data;
    const typicalOcurrence = filterTypicalOccurrence(data?.solicitationType);
    const areadIdFiltered = filterArea(data?.area) || cookie?.chamadoWoba.ambiente?.value;
    const token = cookie.authToken;
    const payload = parseJwt(token);
    const companyId = cookie?.chamadoWoba?.empresa;
    const unitId = cookie?.chamadoWoba?.site;
    const now = new Date();
    const ocurrenceData = {
      empresaId: companyId,
      siteId: unitId,
      tipoAnomalia: 19,
      descricao: [data?.nome, data?.email, data?.details].filter(item => item && item.trim()).join(', '),
      dataRegistro: new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString(),
      anomaliaTipicaId: data?.solicitationType,
      grupoAreaId: areadIdFiltered != null ? areadIdFiltered[0]?.grupoArea : null,
      subgrupoAreaId: areadIdFiltered != null ? areadIdFiltered[0]?.subGrupoArea : null,
      areaId: data?.area || cookie?.chamadoWoba?.ambiente?.value || null,
      tipoEquipamentoId: typicalOcurrence[0]?.tipoEquipamentoId,
      equipamentoId: typicalOcurrence[0]?.equipamentoId,
      sistemaEmpresaId: typicalOcurrence[0]?.sistemaEmpresaId,
      prioridadeAnomaliaId: typicalOcurrence[0]?.prioridadeAnomaliaId,
      setorId: typicalOcurrence[0]?.setorId,
      emitentes: [
        {
          emitenteId: payload?.nameid,
        },
      ],
      executores: typicalOcurrence[0]?.executores.map(executor => ({
        executorId: executor.executor,
      })),
      //fotos: imagesPath?.map(path => ({ fotoPath: path })),
      fotos: fotos?.length > 0 ? fotos?.map(foto => ({ fotoPath: foto?.name })) : null,
      //temFoto: imagesPath.length > 0 ? true : false,
      temFoto: fotos?.length > 0 ? true : false,
      plataforma: 1,
      indisponibilidade: false,
    };
    try {
      const chamadoResponse = await ChamadoService.saveOccurences({
        EmpresaId: companyId,
        UnidadeId: unitId,
        data: ocurrenceData,
      });
      if (chamadoResponse.data.success) {
        const fotosPaths = chamadoResponse.data?.fotosResult?.fotoCreatedPaths;
        const filesWithCloudPaths = fotos?.map(file => ({
          file,
          cloudPath: fotosPaths[file.name],
        }));
        try {
          if (fotos && fotos.length > 0) {
            filesWithCloudPaths?.map(imageData =>
              handleImageUpload(imageData, 'AnomaliasFotos', companyId, token, setToastList, cookie),
            );
          }
        } catch (error) {
          console.error('Erro ao fazer upload das imagens:', error.message);
          return;
        }
        setOpenModalSuccess(true);
      }
      setValue('nome', '');
      setValue('area', '');
      setValue('solicitationType', '');
      setValue('details', '');
      setValue('email', '');
      setValue('fotos', []);
      logout()
        .then(() => {
          localStorage.setItem('socket', null);
          setAuthContext({
            statusCode: false,
            isAuthenticated: false,
            token: null,
            refreshToken: null,
            expiresIn: null,
            user: {
              name: null,
            },
          });
          removeCookie('authToken', { path: '/', domain: URLS.cookieDomain });
          removeCookie('refreshToken', { path: '/', domain: URLS.cookieDomain });
          removeCookie('qrcodeFilters', { path: '/', domain: URLS.cookieDomain });
          removeCookie('openNewChamado', { path: '/', domain: URLS.cookieDomain });
          removeCookie('chamadoRoute', { path: '/', domain: URLS.cookieDomain });
          removeCookie('lastLoginRoute', { path: '/', domain: URLS.cookieDomain });
          window.localStorage.clear();
        })
        .catch(error => {
          console.error({ error });
          window.localStorage.clear();
        });
    } catch (error) {
      createErrorToast(setToastList, 'Ops! Algo deu errado. Tente novamente em alguns instantes');
      console.error('Erro:', error);
      Sentry.captureException(error);
    }
  };
  const logout = async () => {
    const token = cookie.authToken;
    await AuthService.logout({ token });
  };
  const filterTypicalOccurrence = id => {
    return fields.typical.filter(({ value }) => value === id);
  };
  const filterArea = id => {
    if (id) return fields?.area?.filter(({ value }) => value === id);
    return null;
  };
  return (
    <ThemeProvider theme={theme}>
      <Page>
        {loading && <Loading />}
        <FormWrapper width={isDesktop ? '552px' : '328px'}>
          <Header>
            <Logo />
          </Header>
          <SubTitle>{theme.labels.formTitle}</SubTitle>
          <PageDisclaimer>{theme.labels.formSubtitle}</PageDisclaimer>
          {/*aqui vai o valor dinamico posteriormente */}
          {theme.empresaId === 7015 && (
            <QrcodeUnitInfo>
              QR code da Unidade: {cookie?.chamadoWoba?.nome} | {cookie?.chamadoWoba?.endereco}
            </QrcodeUnitInfo>
          )}
          <FormInputsWrapper>
            <FormProvider {...methods}>
              <FieldRow marginBottom="30px" />
              {theme.fields.ambienteQrCodeTable && (
                <QrcodeTableInfo width={isDesktop ? '552px' : '328px'}>
                  <QrcodeTableInfoIcon>
                    <QrcodeIcon />
                  </QrcodeTableInfoIcon>
                  <QrcodeTableInfoBody>
                    <div>
                      <b>Unidade: </b>
                      {cookie?.chamadoWoba?.nome}
                    </div>
                    <div></div>
                    <div>
                      <b>Ambiente:</b>
                      {cookie?.chamadoWoba?.ambiente?.label}
                    </div>
                  </QrcodeTableInfoBody>
                </QrcodeTableInfo>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.nome && (
                <>
                  <StyledFormGroup label={theme.labels.nome} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      name="nome"
                      defaultValue={''}
                      control={control}
                      rules={{ required: 'Este campo é obrigatório' }}
                      render={props => (
                        <StyledInputMask
                          placeholder="  "
                          onChange={props.onChange}
                          styled={{ height: '32px' }}
                          error={Boolean(errors.nome)}
                          {...props}
                        ></StyledInputMask>
                      )}
                    />
                    {errors.nome && <ErrorText>{errors.nome.message}</ErrorText>}
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.area && (
                <>
                  <StyledFormGroup label={theme.labels.area} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      name="area"
                      defaultValue={''}
                      control={control}
                      rules={{ required: 'Este campo é obrigatório' }}
                      render={props => (
                        <StyledSelect
                          {...props}
                          placeholder="Selecionar"
                          options={fields?.area}
                          error={!!errors.area}
                          onChange={value => {
                            props.onChange(value);
                            fetchData();
                          }}
                        />
                      )}
                    />
                    {errors.area && <ErrorText>{errors.area.message}</ErrorText>}
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.solicitationType && (
                <>
                  <StyledFormGroup label={theme.labels.solicitationType} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      control={control}
                      name="solicitationType"
                      rules={{ required: 'Este campo é obrigatório' }}
                      render={props => <SelectCheckbox {...props} options={fields?.typical} />}
                    />
                    {errors.solicitationType && <ErrorText>{errors.solicitationType.message}</ErrorText>}
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.category && (
                <>
                  <StyledFormGroup label={theme.labels.category} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      name="category"
                      defaultValue={''}
                      control={control}
                      rules={{ required: 'Este campo é obrigatório' }}
                      render={props => (
                        <StyledSelect
                          {...props}
                          placeholder="Selecionar"
                          options={fields?.typical}
                          error={!!errors.category}
                        />
                      )}
                    />
                    {errors.category && <ErrorText>{errors.category.message}</ErrorText>}
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.details && (
                <>
                  <StyledFormGroup label={theme.labels.details} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      name="details"
                      defaultValue={''}
                      control={control}
                      rules={{ required: 'Este campo é obrigatório' }}
                      render={props => (
                        <Textarea
                          {...props}
                          ref={textAreaRef}
                          error={!!errors.details}
                          placeholder="Descreva o que aconteceu para que possamos te ajudar da melhor forma"
                          width={isDesktop ? '552px' : '328px'}
                          size={'custom'}
                          customStyle={{
                            padding: '12px',
                            resize: 'none',
                            overflow: 'hidden',
                            minHeight: '72px',
                          }}
                        />
                      )}
                    />
                    {errors.details && <ErrorText>{errors.details.message}</ErrorText>}
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.email && (
                <>
                  <StyledFormGroup label={theme.labels.email} width={isDesktop ? '552px' : '328px'}>
                    <Controller
                      name="email"
                      defaultValue={''}
                      control={control}
                      render={props => (
                        <StyledInputMask
                          placeholder="  "
                          onChange={props.onChange}
                          styled={{ height: '32px' }}
                          {...props}
                        ></StyledInputMask>
                      )}
                    />
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              {theme.fields.fotos && (
                <>
                  <StyledFormGroup label={'Fotos'} width={isDesktop ? '552px' : '328px'}>
                    <ImageUpload inputName={'fotos'} isMobile={!isDesktop} width={isDesktop ? '552px' : '328px'} />
                  </StyledFormGroup>
                </>
              )}
              <FieldRow marginBottom="30px" />
              <SaveButton onClick={handleSubmit(handleSave)}>Enviar</SaveButton>
            </FormProvider>
          </FormInputsWrapper>
        </FormWrapper>
        <SuccessModal
          hasHeader
          title="Seu chamado foi aberto com sucesso"
          icon={<SuccessIcon />}
          size={{ width: `${isDesktop ? '552px' : '337px'}` }}
          success={true}
          open={openModalSuccess}
          closeModal={closeModals}
        >
          <p>Em breve será atendido.</p>
          <SaveButton onClick={closeModals}>Entendi</SaveButton>
        </SuccessModal>
        <Toast toastList={toastList} autoDelete dismissTime={7000} />
      </Page>
    </ThemeProvider>
  );
};
